"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReactElementRef = getReactElementRef;
var React = _interopRequireWildcard(require("react"));
/**
 * Extracts the `ref` from a React element, handling different React versions.
 */
function getReactElementRef(element) {
  if (! /*#__PURE__*/React.isValidElement(element)) {
    return null;
  }
  const reactElement = element;
  const propsWithRef = reactElement.props;
  const refFromProps = propsWithRef?.ref;
  return refFromProps ?? reactElement.ref ?? null;
}